import React from "react";

type ApplicationStatus =
  | "saved"
  | "applied"
  | "interview"
  | "offer"
  | "rejected"
  | "expired"
  | "deleted";

type SemanticVariant = "success" | "warning" | "error";

type BadgeVariant = ApplicationStatus | SemanticVariant;

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  // Application status
  saved:      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  applied:    "bg-accent-light text-accent dark:bg-indigo-900 dark:text-indigo-200",
  interview:  "bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-200",
  offer:      "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200",
  rejected:   "bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-300",
  expired:    "bg-orange-100 text-orange-600 dark:bg-orange-900 dark:text-orange-300",
  deleted:    "bg-slate-200 text-slate-400 dark:bg-slate-700 dark:text-slate-500",
  // Semantic
  success:    "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200",
  warning:    "bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-200",
  error:      "bg-red-100 text-red-600 dark:bg-red-900 dark:text-red-300",
};

export function Badge({ variant, children, className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
